var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricing6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#2463EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 10.418C13.3307 12.5013 11.8724 13.543 10.1391 14.1472C10.0483 14.1779 9.9497 14.1764 9.8599 14.143C8.1224 13.543 6.66406 12.5013 6.66406 10.418V7.50133C6.66406 7.39082 6.70796 7.28484 6.7861 7.2067C6.86424 7.12856 6.97022 7.08466 7.08073 7.08466C7.91406 7.08466 8.95573 6.58466 9.68073 5.95133C9.769 5.87591 9.88129 5.83447 9.9974 5.83447C10.1135 5.83447 10.2258 5.87591 10.3141 5.95133C11.0432 6.58883 12.0807 7.08466 12.9141 7.08466C13.0246 7.08466 13.1306 7.12856 13.2087 7.2067C13.2868 7.28484 13.3307 7.39082 13.3307 7.50133V10.418Z",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing6);
export default __webpack_public_path__ + "static/media/pricing 6.33da09f9c057b60ef63d2ae7213c35e6.svg";
export { ForwardRef as ReactComponent };